var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.4C0.776142 10.4 1 10.6239 1 10.9V13.4C1 13.9523 1.44772 14.4 2 14.4H14C14.5523 14.4 15 13.9523 15 13.4V10.9C15 10.6239 15.2239 10.4 15.5 10.4C15.7761 10.4 16 10.6239 16 10.9V13.4C16 14.5046 15.1046 15.4 14 15.4H2C0.895431 15.4 0 14.5046 0 13.4V10.9C0 10.6239 0.223858 10.4 0.5 10.4Z",
    fill: "#3A83F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64645 12.3536C7.84171 12.5488 8.15829 12.5488 8.35355 12.3536L11.3536 9.35355C11.5488 9.15829 11.5488 8.84171 11.3536 8.64645C11.1583 8.45118 10.8417 8.45118 10.6464 8.64645L8.5 10.7929V2C8.5 1.72386 8.27614 1.5 8 1.5C7.72386 1.5 7.5 1.72386 7.5 2V10.7929L5.35355 8.64645C5.15829 8.45118 4.84171 8.45118 4.64645 8.64645C4.45118 8.84171 4.45118 9.15829 4.64645 9.35355L7.64645 12.3536Z",
    fill: "#3A83F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.98ff08ba0fcc138b280c4be78b26a860.svg";
export { ForwardRef as ReactComponent };